import { TabList as MUITabList, type TabListProps } from "@mui/lab";
import { C_OUTLINE_VARIANT, C_PRIMARY } from "../icon/Colors";
import { makeStyles } from "@mui/styles";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "../../../utils/screenSizes";
import { type CSSProperties } from "react";

interface Props extends Omit<TabListProps, "onChange" | "classes" | "variant"> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (e: any, value: string, nestedValue: string) => void;
  maxTabAmount?: number;

  variant?: "fullWidth" | "scrollable" | "standard" | "oneNth";
}

const MAX_TAB_AMOUNT = 7;

const useDefaultStyles = makeStyles({
  root: {
    position: "relative",
    minHeight: "40px",
    [`@media ${MEDIA_QUERY_MIN_DESKTOP_S}`]: {
      minHeight: "40px",
    },

    "&:before": {
      content: '""',
      position: "absolute",
      left: "0",
      right: "0",
      bottom: "0",
      borderBottom: `1px solid ${C_OUTLINE_VARIANT}`,
    },
  },

  indicator: {
    height: "3px",
    backgroundColor: C_PRIMARY,
  },

  flexContainer: {
    "& > .MuiTab-root": {
      flex: 1,
      width: (props: Props) => (props.variant === "oneNth" ? "50%" : "auto"),
      maxWidth: "50%",
      [`@media ${MEDIA_QUERY_MIN_DESKTOP_S}`]: {
        flex: "none",
        width: (props: Props) => (props.variant === "oneNth" ? `calc(100% / var(--max-tab-amount, 7))` : "auto"),
        maxWidth: "none",
      },
    },
  },

  fullWidth: {
    "& $flexContainer": {
      "& > .MuiTab-root": {
        flex: "1  !imporant",
        width: "50%  !imporant",
        maxWidth: "50% !imporant",
      },
    },
  },
});

const TabList = ({ variant = "fullWidth", maxTabAmount = MAX_TAB_AMOUNT, ...rest }: Props) => {
  const classes = useDefaultStyles({ ...rest, variant });
  const style = { ...(rest.style ?? {}), "--max-tab-amount": maxTabAmount } as CSSProperties;

  // @ts-ignore
  return <MUITabList {...rest} classes={classes} variant={variant === "oneNth" ? "standard" : variant} style={style} />;
};

export default TabList;
